import type { FC } from 'react'

import AccountEditIcon from 'mdi-react/AccountEditIcon'

import { Translation } from '@/app/translations/Translation'
import DataPoints, { DataPoint } from '@/components/DataPoints'
import { LocalDateTime } from '@/components/LocalDateTime'
import type { AssetExtended } from '@/modules/admin/resources'

export const Edits: FC<{ assetDetails: AssetExtended }> = ({ assetDetails }) => {
  const { createdUserName, createdDate, isMigratedIntoEcom, editorUserName, editedDate, source } =
    assetDetails

  const isManuallyCreatedBy =
    assetDetails?.ecomOrderId === null && assetDetails?.devicePolicyOrderId === null

  return (
    <section className="shadow-basic m-2 flex flex-1 basis-[30rem] rounded-md bg-white p-4">
      <DataPoints>
        <h3>
          <Translation id="Edits" />
        </h3>
        <DataPoint
          header={<Translation id={isManuallyCreatedBy ? 'Manually Created by' : 'Created by'} />}
          value={
            <>
              <span>{createdUserName != null && createdUserName ? createdUserName : ' - '}</span>
              {isManuallyCreatedBy && (
                <span>
                  {' '}
                  <AccountEditIcon className="h-4 w-4 align-middle" />
                </span>
              )}
            </>
          }
        />
        <DataPoint
          header={<Translation id="Created" />}
          value={<LocalDateTime date={createdDate} />}
        />
        {isMigratedIntoEcom ? (
          <DataPoint header={<Translation id="Migrated to Ecom" />} value="Yes" />
        ) : null}
        <DataPoint header={<Translation id="Last Edited by" />} value={editorUserName} />
        <DataPoint
          header={<Translation id="Last Edited" />}
          value={<LocalDateTime date={editedDate} />}
        />
        <DataPoint header={<Translation id="Source" />} value={source} />
      </DataPoints>
    </section>
  )
}
